<!-- <h2 class="uk-flex uk-flex-center uk-text-bold uk-text-secondary" *ngIf="state == 'notfound'">{{ content.header }}</h2>
<h2 class="uk-flex uk-flex-center uk-text-bold uk-text-secondary" *ngIf="state != 'notfound'">{{ content.header }}</h2> -->
<div class="fullscreen">
</div>  
<div>
  <h2 class="uk-flex uk-flex-center uk-text-bold uk-text-secondary" >{{ content().header }}</h2>
    <div class="uk-flex uk-flex-center" *ngFor="let body of content().body">
      <h4 class="uk-text uk-text-secondary">{{ body }}</h4>
    </div>
    <div *ngIf="linkMessage()">
      <h4 class="uk-flex uk-flex-center">
        <a class="uk-link-text uk-text-primary" uk-icon="icon: link" (click)="closeLiff()">{{linkMessage()}}</a>
      </h4>
    </div>
    <p style="margin-top: 60%;" class="uk-flex uk-flex-center" >referenceUUID:{{referenceUUID}}</p>
</div>
  